export default "__VITE_ASSET__BHrf_3KP__"